import { MSG, type Me } from "@genbaryoku/contract";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router";
import { api, messageOf } from "../api.js";
import { setMe } from "../auth.js";
import { AuthCard, ErrorText, useToast } from "../components/ui.jsx";

/** 「確認メールを送りました」。届かないときの逃げ道（確認メールを再送／会員登録画面へ）をここに置く */
export function SignupSentPage() {
  const loc = useLocation();
  const nav = useNavigate();
  const qc = useQueryClient();
  const email = (loc.state as { email?: string } | null)?.email;
  const { toast, node } = useToast();
  const [err, setErr] = useState<string | undefined>();
  const [busy, setBusy] = useState(false);
  if (!email) return <Navigate to="/signup" replace />;

  const resend = async () => {
    setBusy(true);
    setErr(undefined);
    try {
      const r = await api<{ email: string } | Me>("POST", "/auth/resend-verification", { email });
      // 海外の IP（#110）：確認コードの窓で確かめ終えると、確認済みでログインした Me が返る
      if ("user" in r) {
        await setMe(qc, r);
        nav("/home", { replace: true });
        return;
      }
      toast("確認メールを送り直しました。");
    } catch (e) {
      setErr(messageOf(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="確認メールを送りました" mode="signup">
      <p>
        <b className="num" style={{ fontSize: "var(--fs-19)" }}>{email}</b> 宛てに、登録を確かめるメールを送りました。
      </p>
      <p>
        メールの中の <b>「登録を完了する」</b> を押すと、そのまま使い始められます。
      </p>
      <p className="hint">{MSG.signupSentNote}</p>
      <ErrorText>{err}</ErrorText>
      <div className="authlinks">
        <button type="button" className="btn text" onClick={resend} disabled={busy}>確認メール再送</button>
        <span>
          アドレスを間違えた → <Link className="btn text" to="/signup">会員登録画面へ</Link>
        </span>
      </div>
      {node}
    </AuthCard>
  );
}
